// This file includes polyfills needed by Angular and is loaded before the app.
// You can add your own extra polyfills to this file.

// required JS method support (mostly for IE) - features only to minimise JS bundle
import 'core-js/features/object/entries';
import 'core-js/features/object/assign';
import 'core-js/features/object/values';
import 'core-js/features/typed-array/from';
import 'core-js/features/promise';
import 'core-js/features/array/includes';
import 'core-js/features/string/includes';
import 'core-js/features/weak-set';

import 'url-search-params-polyfill'; // IE fix for linkedin redirect

import 'zone.js';

// fix for IE "object does not support matches" error
if (!Element.prototype.matches) {
	Element.prototype.matches =
		(Element.prototype as any).msMatchesSelector ||
		Element.prototype.webkitMatchesSelector;
}
import 'whatwg-fetch';

// Animations

// Date, currency, decimal and percent pipes
// Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
// import 'intl';

// NgClass on SVG elements
// Needed for: IE10, IE11

// fixing bugs fro aws-amplify (process is not defined)
import * as process from 'process';
(window as any).process = process;
